(ns dre.widgets.geography.views
  (:require
   [clojure.string :as str]
   [dre.components.icon :refer [fa-icon]]
   [dre.components.worldmap :as viz]
   [dre.components.widget.views :as widget-base]
   [dre.components.widget.views.common :refer [no-result title-with-filter]]
   [dre.components.widget.views.table-list :refer [table-list]]
   [dre.i18n.views :refer [tr]]
   [dre.widgets.geography.events :as events]
   [dre.components.widget.events :as wevents]
   [dre.pages.search.events :as search-events]
   [re-frame.core :as rf]))

(defn widget-content
  [_id _selected-type _selected-tab]
  (fn [id selected-type selected-tab]
    (let [data @(rf/subscribe [::events/data selected-type])
          {:keys [top-countries count-by-codes]} data]
      [:<>
       (if (not (seq top-countries))
         [no-result true]
         (cond 
           (= selected-tab :map)
           [viz/worldmap
            {:country-counts
             count-by-codes
             :done
             (fn [datamap]
               (let [select
                     (fn [geo]
                       (let [country-code (-> (.-id geo) str/upper-case)
                             d (get count-by-codes country-code)]
                         (when d
                           (rf/dispatch [::search-events/widget-filter-select id (events/->country-pill d (:type d))]))))]
                 (-> (.-svg datamap)
                     (.selectAll ".datamaps-subunit")
                     (.on "click" select))
                 datamap))}]
           :else
           [table-list "geography-table" top-countries {:sort-fn :idx}]))])))

(defn view
  [id title]
  (let [state @(rf/subscribe [::events/state])
        loading? (= :loading (:state state))
        default-type :mentions
        default-tab :map
        selected-type @(rf/subscribe [::wevents/selection id ::type])
        selected-tab @(rf/subscribe [::wevents/selection id ::display])
        selected-type (if (not selected-type)
                        default-type
                        selected-type)
        selected-tab (if (not selected-tab)
                       default-tab
                       selected-tab)]
    [widget-base/view id [title-with-filter title id] [widget-content id selected-type selected-tab]
     {:csv-event [::events/export selected-type]
      :export-image? true
      :selections
      [{:id ::type
        :type :dropdown
        :default-option default-type
        :options [{:id :mentions :label [tr "Mentions"]}
                  {:id :study-center :label [tr "Study Centers"]}
                  {:id :affiliations :label [tr "Author Affiliations"]}]}
       {:id ::display
        :type :tabs
        :default-option default-tab
        :options [{:id :map :label [fa-icon :globe]}
                  {:id :list :label [fa-icon :list]}]}]}
     {:loading? loading?}]))